import { motion } from "framer-motion";
import { toast } from "sonner";
import { CheckCircle2, Download, ArrowLeft, Mail, Clock } from "lucide-react";

const LOGO = "/assets/logo.png";

const EBOOKS = [
  { title: "The Ultimate Faceless Marketing Guide", file: "/ebooks/the-ultimate-faceless-marketing-guide.pdf" },
  { title: "Faceless Youtube Automation For Passive Profits", file: "/ebooks/faceless-youtube-automation-for-passive-profits.pdf" },
  { title: "Faceless TikTok Guide for Digital Marketing", file: "/ebooks/faceless-tiktok-guide-for-digital-marketing.pdf" },
  { title: "The Ultimate Faceless Instagram Guide", file: "/ebooks/the-ultimate-faceless-instagram-guide.pdf" },
  { title: "Mastering Your Faceless Instagram Reels", file: "/ebooks/mastering-your-faceless-instagram-reels.pdf" },
  { title: "Chat GPT And Canva", file: "/ebooks/chat-gpt-and-canva.pdf" },
  { title: "Faceless Digital Marketing", file: "/ebooks/faceless-digital-marketing.pdf" },
  { title: "Mastering Etsy and Pinterest MRR", file: "/ebooks/mastering-etsy-and-pinterest-mrr.pdf" },
  { title: "Mastering The World Of Social Media", file: "/ebooks/mastering-the-world-of-social-media.pdf" },
  { title: "eMail Marketing For Beginners", file: "/ebooks/email-marketing-for-beginners.pdf" },
  { title: "TikTok Money Guide", file: "/ebooks/tiktok-money-guide.pdf" },
];

export default function ThankYou() {
  const notReady = () => {
    toast.info("This ebook is being finalized and will be available here very soon.");
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white grain relative">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="flex items-center gap-3 mb-16">
          <img src={LOGO} alt="The Faceless Bundle logo — faceless digital marketing ebooks to monetize social media" className="w-9 h-9 object-contain" />
          <span className="font-serif-display text-lg tracking-[0.25em] font-semibold">
            THE FACELESS BUNDLE<span className="text-[#D4AF37]">.</span>
          </span>
        </div>

        <motion.div
          data-testid="thankyou-success"
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex flex-col items-center text-center">
            <div className="w-20 h-20 flex items-center justify-center border border-[#D4AF37]/40 bg-[#D4AF37]/5">
              <CheckCircle2 className="w-10 h-10 text-[#D4AF37]" />
            </div>
            <span className="mt-6 text-sm uppercase tracking-[0.25em] text-[#D4AF37]">Payment successful</span>
            <h1 className="font-serif-display text-4xl sm:text-5xl font-bold mt-4">
              Welcome to your faceless empire
            </h1>
            <p className="mt-6 text-lg text-zinc-400 max-w-xl">
              Thank you for your purchase! Your complete 11-ebook Faceless Marketing Bundle
              is ready below. Download each guide and start building today.
            </p>
          </div>

          <div className="mt-16">
            <h2 className="font-serif-display text-2xl font-semibold mb-6">Your Downloads</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {EBOOKS.map((book, i) => {
                const ready = Boolean(book.file);
                const content = (
                  <>
                    <div className="flex items-center gap-4">
                      <span className="font-serif-display text-lg text-zinc-600">{String(i + 1).padStart(2, "0")}</span>
                      <span className="text-sm font-medium">{book.title}</span>
                    </div>
                    {ready ? (
                      <Download className="w-5 h-5 text-zinc-500 group-hover:text-[#D4AF37] transition-colors shrink-0" />
                    ) : (
                      <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-zinc-600 shrink-0">
                        <Clock className="w-3.5 h-3.5" /> Soon
                      </span>
                    )}
                  </>
                );
                return ready ? (
                  <a
                    key={i}
                    href={book.file}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`download-item-${i}`}
                    className="group flex items-center justify-between gap-4 bg-[#121212] border border-zinc-800 p-5 text-left hover:border-[#D4AF37]/50 transition-colors"
                  >
                    {content}
                  </a>
                ) : (
                  <button
                    key={i}
                    onClick={notReady}
                    data-testid={`download-item-${i}`}
                    className="group flex items-center justify-between gap-4 bg-[#121212]/60 border border-zinc-800/60 p-5 text-left cursor-default"
                  >
                    {content}
                  </button>
                );
              })}
            </div>

            <div className="mt-10 flex items-center gap-3 text-sm text-zinc-500 border-t border-zinc-900 pt-8">
              <Mail className="w-5 h-5 text-[#D4AF37]" />
              A copy of your download links has also been reserved for your email.
            </div>

            <a href="/" className="inline-flex items-center gap-2 mt-10 text-sm text-zinc-400 hover:text-[#D4AF37] transition-colors">
              <ArrowLeft className="w-4 h-4" /> Back to store
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
